/* eslint-disable */
import { formatFileSize, isDefinedGlobally } from './utils';

// If you need the field name use `${field}` in the messages
const messages = {
    _default: (field) => `Diese Eingabe ist ungültig.`,
    after: (field, [target]) => `Dieses Feld muss nach ${target} liegen.`,
    alpha: (field) => `Diese Eingabe darf nur alphabetische Zeichen enthalten.`,
    alpha_dash: (field) => `Diese Eingabe darf alphanumerische Zeichen sowie Striche und Unterstriche enthalten.`,
    alpha_num: (field) => `Diese Eingabe darf nur alphanumerische Zeichen enthalten.`,
    alpha_spaces: (field) => `Diese Eingabe darf nur alphanumerische Zeichen und Leerzeichen enthalten.`,
    before: (field, [target]) => `Dieses Feld muss vor ${target} liegen.`,
    between: (field, [min, max]) => `Die Eingabe muss zwischen ${min} und ${max} liegen.`,
    confirmed: (field) => `Die Wiederholung stimmt nicht überein`,
    credit_card: (field) => `Diese Eingabe ist keine gültiger Wert für Kreditkarten.`,
    date_between: (field, [min, max]) => `Diese Eingabe muss zwischen ${min} und ${max} liegen.`,
    date_format: (field, [format]) => `${format}`,
    decimal: (field, [decimals = '*'] = []) => `Diese Eingabe muss numerisch sein und darf${decimals === '*' ? '' : ' ' + decimals} Dezimalpunkte enthalten.`,
    digits: (field, [length]) => `Diese Eingabe muss numerisch sein und exakt ${length} Ziffern enthalten.`,
    dimensions: (field, [width, height]) => `Dieses Eingabe muss ${width} x ${height} Bildpunkte groß sein.`,
    email: (field) => `Keine gültige E-Mail`,
    excluded: (field) => `Diese Eingabe muss gültig sein.`,
    ext: (field) => `Diese Eingabe muss eine gültige Datei sein.`,
    image: (field) => `Diese Eingabe ist keine gültige Grafik.`,
    included: (field) => `Diese Eingabe muss gültig sein.`,
    integer: (field) => `Diese Eingabe muss eine ganze Zahl sein.`,
    ip: (field) => `Diese Eingabe ist keine gültige IP-Adresse.`,
    length: (field, [length, max]) => {
        if (max) {
            return `Die Länge dieser Eingabe muss zwischen ${length} und ${max} liegen.`;
        }

        return `Die Länge dieser Eingabe muss ${length} sein.`;
    },
    max: (field, [length]) => `Diese Eingabe darf nicht länger als ${length} Zeichen sein.`,
    max_value: (field, [max]) => `Dieses Eingabe darf ${max} nicht überschreiten.`,
    mimes: (field) => `Ungültiger Dateityp.`,
    min: (field, [length]) => `Dieses Eingabe muss mindestens ${length} Zeichen lang sein.`,
    min_value: (field, [min]) => `Dieses Eingabe darf ${min} nicht unterschreiten.`,
    numeric: (field) => `Nicht numerisch`,
    regex: (field) => `Das Format dieser Eingabe ist ungültig.`,
    required: (field) => `Pflichtfeld`,
    size: (field, [size]) => `Diese Eingabe muss kleiner als ${formatFileSize(size)} sein.`,
    url: (field) => `Diese Eingabe ist keine gültige URL.`,
};

const locale = {
    name: 'de',
    messages,
    attributes: {}
};

if (isDefinedGlobally()) {
    VeeValidate.Validator.localize({ [locale.name]: locale });
}

export default locale;
